export const equipmentNavigation = [
  {
    name: 'equipment_navigation_info',
    value: '',
    type: 'textarea',
    placeholder: 'INFO',
    className: 'mt-2'
  }
];
